import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';
import sal from 'sal.js';

import Layout from '~/layouts/modal';

import './work-detail.scss';

import XMEPayLogo from '~/assets/images/icons/logos/xme-pay-logo.svg';
import XMEPayLogoPrintable from '~/assets/images/icons/logos/xme-pay-logo-printable.svg';
import Eighteen79Logo from '~/assets/images/icons/logos/eighteen79-logo.svg';
import UniwhereLogo from '~/assets/images/icons/logos/uniwhere-logo.svg';
import WeAppHeroesLogo from '~/assets/images/icons/logos/weappheroes-logo.svg';
import ZalandoLogo from '~/assets/images/icons/logos/zalando-logo.svg';

import SEO from '~/components/seo';

export const WorkDetailTemplate = ({ metadata, content }) => pug`
  .work-detail__main
    .work-detail__title
      .centered-container
        .work-detail__logo(data-sal="slide-down")
          if metadata.projectKey == 'xmepay'
            XMEPayLogo.hidden-print
            XMEPayLogoPrintable.shown-print
          else if metadata.projectKey == 'eighteen79'
            Eighteen79Logo
          else if metadata.projectKey == 'uniwhere'
            UniwhereLogo
          else if metadata.projectKey == 'zalando'
            ZalandoLogo
          else if metadata.projectKey == 'weappheroes'
            WeAppHeroesLogo
          else
            | 🌴
    .work-detail__info.grid.grid--thirds
      .work-detail__info__study(dangerouslySetInnerHTML={ __html: content }, data-sal="slide-up", style={ transitionDelay: '0.1s' })
      .work-detail__info__metadata(data-sal="slide-up")
        h3.hidden-print=metadata.title
        .work-detail__info__metadata__entries
          .work-detail__info__metadata__entry
            h5 Role
            p=metadata.role
          .work-detail__info__metadata__entry.area
            h5 Areas
            ul
              each area in metadata.areas
                li(key=area)=area
          .work-detail__info__metadata__entry
            h5 Start Date
            p=metadata.startDate
          .work-detail__info__metadata__entry
            h5 End Date
            p=metadata.endDate
`;

WorkDetailTemplate.propTypes = {
  metadata: PropTypes.object,
  content: PropTypes.string,
};

class WorkDetail extends React.Component {
  componentDidMount() {
    sal({
      threshold: 0,
    });
  }

  render() {
    const { data, location } = this.props;
    const metadata = { ...data.markdownRemark.frontmatter };
    const { html: content } = data.markdownRemark;

    const previousHref = location.state ? location.state.previousHref : '';

    const description = metadata.summary.join('. ');

    return pug`
      Layout.work-detail(to="/work", previousHref=previousHref, style={'--color-interaction': '#' + metadata.color}, className=metadata.projectKey)
        SEO(title=metadata.title, description=description)
        WorkDetailTemplate(metadata=metadata, content=content)
    `;
  }
}

WorkDetail.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.object,
  }),
  location: PropTypes.object,
};

export default WorkDetail;

export const pageQuery = graphql`
  query WorkById($id: String!) {
    markdownRemark(id: {eq: $id}) {
      id
      frontmatter {
        title
        color
        projectKey
        role
        areas
        startDate
        endDate
        summary
      }
      html
    }
  }
`;
